import { HTTP_YAF } from "@/service/axios";
import { ElMessage } from "element-plus";
export async function getPermissionList() {
  try {
    // 获取权限
    let roleauthlist = await HTTP_YAF.post("/user/user/getroleauthlist", {
      platform_id: 140,
    });
    return roleauthlist[0] || {};
  } catch (error) {
    if (error.message && typeof error.message === "object") {
      return {};
    }
    ElMessage({
      type: "error",
      message: error.message || error.msg || "网络异常",
    });
    return {};
  }
}

export function transform(list) {
  let obj = {};
  let contents = list.filter((v) => v.power_type == 1);
  let nav = list.filter((v) => v.power_type == 2);
  let btn = list.filter((v) => v.power_type == 3);
  contents.forEach((item) => {
    let key = item.router_node;
    if (obj[key]) {
      obj[key] = [];
      if (!item.has_role) {
        obj[key].push("LOOK");
      }
    }
  });
  nav.forEach((item) => {
    let key = item.router_node;
    let child = btn.filter((v) => +v.pid == +item.power_id && v.has_role);
    if (!obj[key]) {
      obj[key] = [];
      if (child.length > 0) {
        child.forEach((v) => {
          if (v.router_node == `${key}_LOOK`) {
            obj[key].push("LOOK");
          } else {
            obj[key].push("LOOK");
          }
        });
      }
    }
  });
  return obj;
}

export default getPermissionList;
